const TEST_TABLE_ID = 'prctbl_1LkH6ELtwRD665km02jLXHsL';
const PROD_TABLE_ID = 'prctbl_1LgCbXLtwRD665kmkjVQRowX';
let tableId = TEST_TABLE_ID;

// eslint-disable-next-line max-len
const TEST_KEY = 'pk_test_51Lg7CFLtwRD665kmXHtS0DmDxZFv3iun55KyLpUjJUtNlBhC2Y0KHVHB385srQvnzKaNJtDvRgMbG7AwysgBs3K5004xNkHmoL';
// eslint-disable-next-line max-len
const PROD_KEY = 'pk_live_51Lg7CFLtwRD665kmRUr0aTfPhrSCgEpNX28PueQzpTXK7fuqzxN0mWLOYNEgtt3pF1LSL0aXOJAXvvBPDIS5wLOT00zivDCm7B';
let key = TEST_KEY;

if (process.env.REACT_APP_ENV === 'prod') {
  tableId = PROD_TABLE_ID;
  key = PROD_KEY;
}

export const STRIPE_TABLE_ID = tableId;
export const STRIPE_KEY = key;
